import React from "react";
import PropTypes from "prop-types";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import DigiFormField from "./DigiFormField";
import DigiFormSelect from "./DigiFormSelect";
import DigiFormTextArea from "./DigiFormTextArea";
import Switch from "react-switch";

const sortNumber = (a, b) =>
  a.sort !== undefined && b.sort !== undefined ? a.sort - b.sort : 0;

const emptyField = (sort) => ({
  _id: new Date().getTime(),
  label: "",
  field_type: "0",
  required: false,
  select_options: "",
  sort: sort,
  show_index: true,
  _destroy: false,
});

const Field = ({
  customField,
  fieldTypes,
  requiredOptions,
  index,
  formName,
  fieldErrors,
  onChangeField,
  onDeleteField,
  onToggleField
}) => (
  <div
    style={{
      borderBottom: "1px solid #dadada",
      paddingBottom: 5,
      marginBottom: 10
    }}
  >
    <div className="row">
      <div className="col-md-1">
        <h2
          className="light-grey-text"
          style={{
            position: "relative",
            top: "14px"
          }}
        >
          ☰
        </h2>
      </div>
      <div
        className={`col-xs-12 ${
          customField.field_type.toString() === "12" ? "col-md-5" : "col-md-3"
        }`}
      >
        <DigiFormField
          label="Label"
          name={`${formName}[custom_fields_attributes][${index}][label]`}
          value={customField.label}
          required={true}
          fieldErrors={!customField.label && fieldErrors["custom_fields.label"]
              ? fieldErrors["custom_fields.label"]
              : null
          }
          onChange={e => onChangeField(e.target.value, index, "label")}
        />
      </div>
      <div className={`col-xs-12 ${formName === "pool" ? "col-md-2" : "col-md-3"}`}>
        <DigiFormSelect
          label="Type"
          name={`${formName}[custom_fields_attributes][${index}][field_type]`}
          value={customField.field_type}
          options={fieldTypes}
          onChange={e => onChangeField(e.target.value, index, "field_type")}
        />
      </div>
      
      {customField.field_type.toString() === "12" ? null : (
        <div className={`col-xs-12 ${formName === "pool" ? "col-md-2" : "col-md-3"}`}>
          <DigiFormSelect
            pref={`field${index}`}
            label="Required"
            name={`${formName}[custom_fields_attributes][${index}][required]`}
            value={customField.required}
            options={requiredOptions}
            onChange={e => onChangeField(e.target.value, index, "required")}
          />
        </div>
      )}

      {
        formName === "pool" && (
          <div className="col-xs-12 col-md-2">
            <div className="form-group">
              <label id={`switch-label-${index}`} className="control-label word-wrap">
                Chemical Records Column 
              </label>
              <Switch
                checked={customField.show_index}
                onChange={() => {
                  onToggleField(index);
                }}
                onColor="#DADCE1"
                onHandleColor="#3A4590"
                handleDiameter={25}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={20}
                width={48}
                className="react-switch"
                id="material-switch"
                aria-labelledby={`switch-label-${index}`}
              />
            </div>
          </div>
        )
      }

      <div className="col-xs-12 col-md-2">
        <a
          href="javascript:void(0);"
          className="btn btn-text certification-btn-fix"
          onClick={() => {
            onDeleteField(index);
          }}
        >
          REMOVE FIELD
        </a>
      </div>
    </div>

    {["3", "5", 3, 5].includes(customField.field_type) ? (
      <div className="row">
        <div className="col-xs-9">
          <DigiFormField
            pref={`field${index}`}
            label="Options (comma separated)"
            name={`${formName}[custom_fields_attributes][${index}][select_options]`}
            value={customField.select_options}
            onChange={e => onChangeField(e.target.value, index, "select_options")}
          />
        </div>
      </div>
    ) : customField.field_type.toString() === "12" ? (
      <DigiFormTextArea
        label="Description (Markdown supported)"
        name={`${formName}[custom_fields_attributes][${index}][select_options]`}
        value={customField.select_options}
        onChange={e => onChangeField(e.target.value, index, "select_options")}
      />
    ) : null}
  </div>
);

class DigiFormCustomFieldsQuestions extends React.Component {
  state = {
    loading: false,
    fieldErrors: {},
    customFields: this.props.customFields.length == 0 ? [emptyField(1)] : this.props.customFields
  };

  componentWillReceiveProps(newProps) {
    if(this.props != newProps) {
      this.setState({
        fieldErrors: newProps.fieldErrors
      });
    }

  }

  componentDidMount() {
    this.props.onChange(this.state.customFields, "custom_fields_attributes");
  }

  render() {
    const {
      loading,
      customFields,
      fieldErrors
    } = this.state;

    const {
      fieldTypes,
      requiredOptions,
      formName,
      onChange
    } = this.props;

    return (
      <div>
        <div
          style={{
            borderBottom: "1px solid #dadada",
            paddingBottom: 5,
            marginBottom: 10
          }}
        >
          <h4>Custom Fields</h4>
        </div>

        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div ref={provided.innerRef}>
                {customFields.sort(sortNumber).map((customField, index) =>
                  customField._destroy ? null : (
                    <Draggable
                      key={customField.id || customField._id || index}
                      draggableId={customField.id || customField._id || index}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <Field
                            customField={customField}
                            fieldTypes={Object.entries(fieldTypes)}
                            requiredOptions={requiredOptions}
                            index={index}
                            formName={formName}
                            fieldErrors={fieldErrors}
                            onChangeField={this.handlerChangeField}
                            onDeleteField={this.handlerDeleteField}
                            onToggleField={this.handlerShowIndex}
                          />
                        </div>
                      )}
                    </Draggable>
                  )
                )}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <div>
          <a
            href="javascript:void(0);"
            className="btn btn-text"
            onClick={this.handlerAddField}
          >
            ADD FIELD
          </a>
        </div>
      </div>
    );
  }

  handlerChangeField = (value, index, key) => {
    const customFields = this.state.customFields;
    customFields[index][key] = value;

    this.setState({ customFields: customFields, fieldErrors: {} });
    this.props.onChange(customFields, "custom_fields_attributes");
  };

  handlerAddField = () => {
    const customFields = this.state.customFields;
    customFields.push(emptyField(this.state.customFields.length +  1));

    this.setState({ customFields: customFields });
    this.props.onChange(customFields, "custom_fields_attributes");
  };

  handlerDeleteField = index => {
    const customFields = this.state.customFields;

    if (customFields[index].id) {
      customFields[index]._destroy = true;
    } else {
      customFields.splice(index, 1);
    }

    this.setState({ customFields: customFields });
    this.props.onChange(customFields, "custom_fields_attributes");
  };

  handlerShowIndex = index => {
    const customFields = this.state.customFields;

    if (customFields[index].id || customFields[index]._id) {
      customFields[index].show_index = !customFields[index].show_index;
    } else {
      customFields.splice(index, 1);
    }

    this.setState({ customFields: customFields });
    this.props.onChange(customFields, "custom_fields_attributes");
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    this.handlerReorder(result.source.index, result.destination.index);
  };

  handlerReorder = (startIndex, endIndex) => {
    const customFields = Array.from(this.state.customFields);
    const [removed] = customFields.splice(startIndex, 1);
    customFields.splice(endIndex, 0, removed);

    customFields.forEach((item, index) => {
      item.sort = index + 1;
    });

    this.handlerRefreshSorting(customFields);
  };

  handlerRefreshSorting = (customFields) => {
    this.setState({customFields: customFields});
    this.props.onChange(this.state.customFields, "custom_fields_attributes");
  };
}

DigiFormCustomFieldsQuestions.propTypes = {
  customFields: PropTypes.array,
  fieldTypes: PropTypes.object,
  requiredOptions: PropTypes.object,
  fieldErrors: PropTypes.object,
  onRefreshSorting: PropTypes.func,
  formName: PropTypes.string
};

export default DigiFormCustomFieldsQuestions;
